import routerOptions0 from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}